import { Button } from '../../../../cdl/Button/Button';
import { useDrawer } from '../../../../cdl/Drawer/useDrawer.hook';
import { useToasts } from '../../../../cdl/Toast/useToasts';
import { translate } from '../../../../common/helpers/translate.helper';
import { IconPlus } from '../../../../common/icons/cdl/Plus';

import { CreatePortForm } from './CreatePortForm';

export const CreatePortButton = () => {
    const { push, pop } = useDrawer();
    const { addToast } = useToasts();

    const openPortCreateModal = () => {
        const onModalClose = () => {
            pop(drawerId);
            addToast(translate('port.createPortSuccessToast'));
        };

        const drawerId = push({
            header: { title: translate('port.createTitle') },
            content: <CreatePortForm onSuccess={onModalClose} />,
        });
    };

    return (
        <Button emphasis="high" LeadingIcon={IconPlus} onClick={openPortCreateModal}>
            {translate('port.createTitle')}
        </Button>
    );
};
